import { useStaticQuery, graphql } from 'gatsby'
import { useMemo } from 'react'

const groupTemplates = templates => {
  const groupMap = templates.reduce((acc, { group, subgroup }) => {
    if (acc.has(group)) {
      const subgroups = acc.get(group)
      subgroups.set(subgroup, (subgroups.get(subgroup) || 0) + 1)
    } else {
      acc.set(group, new Map([[subgroup, 1]]))
    }
    return acc
  }, new Map())

  const groups = Array.from(groupMap.entries()).map(([name, subgroupMap]) => {
    const subgroups = Array.from(
      subgroupMap.entries()).map(e => ({ name: e[0], templateCount: e[1] }),
    )
    const templateCount = subgroups.reduce(
      (acc, sg) => acc + sg.templateCount, 0,
    )
    return { name, subgroups, templateCount }
  })

  return groups
}

const useGalleryData = themeName => {
  const data = useStaticQuery(graphql`
    query {
      allTemplates: allTemplatesYaml {
        templates: nodes {
          ...galleryTemplateFragment
        }
      }
    }
  `)

  const { templates: rawTemplates } = data.allTemplates

  const templates = useMemo(() => {
    return rawTemplates.map(
      ({ images, ...tpl }) => ({ image: images[themeName], ...tpl }),
      [],
    )
  }, [rawTemplates, themeName])

  const groups = useMemo(() => groupTemplates(templates), [templates])

  return { templates, groups }
}

export default useGalleryData
